import { InfoTooltip } from "../common/InfoTooltip";

export function DmAssumptionsTooltip() {
    return <InfoTooltip text="DM assumptions: CDR 2% CPR 20% Recovery 70% to Maturity" />
}